import { render } from "./FaqDetails.vue?vue&type=template&id=0edac899"
import script from "./FaqDetails.vue?vue&type=script&lang=js"
export * from "./FaqDetails.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manzurul\\AppData\\Local\\Jenkins.jenkins\\workspace\\Eznatal-Support-Production\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__